import { QuaiExpressionsV3Lexer } from '@app/hcs-shared/expression/grammar/QuaiExpressionsV3Lexer';
import { QuaiExpressionsV3Parser } from '@app/hcs-shared/expression/grammar/QuaiExpressionsV3Parser';
import { CharStreams, CommonTokenStream } from 'antlr4ts';
import { ExpressionsVisitors } from '../../../../expression-smart-editor/antlr-utils/ExpressionsVisitors.js';
import { ModuleFE_Value } from '../../../../../../../_entity.js';
import { ExpressionsErrorListener } from '../../../../expression-smart-editor/antlr-utils/ErrorsListener.js';
export const getGrammarUtils = (expression, withLogs = false) => {
    const inputStream = CharStreams.fromString(expression);
    const lexer = new QuaiExpressionsV3Lexer(inputStream);
    const tokenStream = new CommonTokenStream(lexer);
    const parser = new QuaiExpressionsV3Parser(tokenStream);
    const expressionsVisitors = new ExpressionsVisitors(withLogs, ModuleFE_Value.cache.unique);
    const errorListener = new ExpressionsErrorListener();
    //
    // //parser syntax listener
    // parser.removeErrorListeners();
    // parser.addErrorListener(errorListener);
    return { resolver: expressionsVisitors, parser: parser, errorListener: errorListener };
};
//# sourceMappingURL=utils.js.map